<template>
    <div class="oneGift">
        <div class="pts">
            <span>{{ giftPoints }}</span>
        </div>

        <div class="vignette">
            <a v-if="giftImage" data-toggle="modal" :data-target="'#layerGift' + giftId">
                <img :data-src="giftImage" :alt="giftTitle" class="lazyload img-fluid">
            </a>
        </div>

        <h3>
            <a href="" data-toggle="modal" :data-target="'#layerGift' + giftId">
                {{ giftTitle }} <span>{{ giftSubtitle }}</span>
            </a>
        </h3>

        <div v-if="showError" class="alert alert-warning">
            Votre solde de points n’est pas suffisant
        </div>

        <button v-if="connected" type="button" @click="update()" class="btn btn-primary">Ajouter au panier</button>

        <div class="modal fade" :id="'layerGift' + giftId" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">{{ giftTitle }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="pts">
                                <span>{{ giftPoints }}</span>
                            </div>

                            <img v-if="giftImage" :data-src="giftImage" :alt="giftTitle" class="lazyload img-fluid">

                            <span v-html="giftDescription"></span>

                            <div v-if="showError" class="alert alert-warning">
                                Votre solde de points n’est pas suffisant
                            </div>

                            <div class="text-center" v-if="connected">
                                <button type="button" @click="update()" class="btn btn-primary">Ajouter au panier</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

    </div>
</template>

<script>

    import {mapActions, mapState, mapGetters} from 'vuex';
    import store from '../store';

    export default {
        name: 'ponroy-gift-card',
        store,
        data() {
            return {
                orderable: {
                    repository: this.repository,
                    id : this.giftId,
                },
                quantity: 1,
                showError: false
            }
        },
        props: {
            repository: {
                type: String,
                required: true,
            },
            giftId: {
                required: true,
            },
            giftPoints: {
                required: true,
            },
            giftImage: {
                required: false,
            },
            giftTitle: {
                required: true,
            },
            giftSubtitle: {
                required: true,
            },
            giftDescription: {
                required: true,
            },
            connected: {
                required: true,
            }
        },
        computed: {
            ...mapGetters('cart', ['fidelityPointLeft']),
        },
        methods: {
            ...mapActions('cart', [
                'addToCart',
            ]),
            ...mapActions('cart', {
                toggle : 'toggleWidget',
            }),
            update() {
                const {orderable, quantity} = this;

                if (this.fidelityPointLeft - this.giftPoints >= 0) {
                    if (orderable.id && quantity) {
                        this.addToCart({orderable, quantity});
                        this.toggle({isNotification: true});
                    }
                } else {
                    this.showError = true;
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/GiftCard.vue